export function convertFileSize(size) {
  const fSizeKb = size / 1024;
  const fSizeMb = fSizeKb / 1024;
  const fSizeGb = fSizeMb / 1024;
  const fSizeTb = fSizeGb / 1024;

  let fSize;

  if (fSizeKb <= 1024) {
    fSize = `${fSizeKb.toFixed(1)} KB`;
  } else if (fSizeKb >= 1024 && fSizeMb <= 1024) {
    fSize = `${fSizeMb.toFixed(1)} MB`;
  } else if (fSizeMb >= 1024 && fSizeGb <= 1024) {
    fSize = `${fSizeGb.toFixed(1)} GB`;
  } else {
    fSize = `${fSizeTb.toFixed(1)} TB`;
  }

  return fSize;
}
